<template>


  <div id="dlnkpartners-admin" class="w-100">

    <dlnkalert
        :message="message"
        :message_type="message_type"
        @close="close_message()"
    ></dlnkalert>


    <div class="modal fade" id="new_page_modal" tabindex="-1" aria-labelledby="new_page_modal_label" aria-hidden="true">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="new_page_modal_label">Ajouter un partenaire</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <form id="new_page_form"
                method="post"
                @submit.prevent="post_page">

            <div class="modal-body">

              <!-- Page title -->
              <div class="row form-group">
                <label for="title" class="col-sm-3 col-form-label input-label">Titre</label>
                <div class="col-sm-9">
                  <input type="text" name="page[title]" id="new_page_title" placeholder="Titre de la page"
                         aria-label="Titre de la page" class="form-control">
                  <div v-if="invalid_new_page_title" class="text-danger">
                    Le titre de la page doit contenir entre 3 et 255 caractères.
                  </div>
                </div>
              </div>
              <!-- END Page title -->

              <!-- Page title_2 -->
              <div class="row form-group">
                <label for="title" class="col-sm-3 col-form-label input-label">Titre 2</label>
                <div class="col-sm-9">
                  <input type="text" name="page[title_2]" id="new_page_title_2" placeholder="Titre 2 de la page"
                         aria-label="Titre 2 de la page" class="form-control">
                  <div v-if="invalid_new_page_title_2" class="text-danger">
                    Le titre 2 de la page doit contenir entre 0 et 128 caractères.
                  </div>
                </div>
              </div>
              <!-- END Page title -->

              <!-- Page join_us -->
              <div class="row form-group">
                <label for="title" class="col-sm-3 col-form-label input-label">
                  Text bouton &laquo; Nous rejoindre &raquo;
                </label>
                <div class="col-sm-9">
                  <input type="text" name="page[join_us]" id="new_page_join_us" placeholder="Nous rejoindre"
                         aria-label="Titre 2 de la page" class="form-control">
                  <div v-if="invalid_new_page_join_us" class="text-danger">
                    Le text du bouton &laquo; Nous rejoindre &raquo; doit contenir entre 0 et 128 caractères.
                  </div>
                </div>
              </div>
              <!-- END Page title -->

              <!-- Page description -->
              <div class="row form-group">
                <label for="new_page_description" class="col-sm-3 col-form-label input-label">
                  Description
                </label>
                <div class="col-sm-9">
                  <ckeditor id="new_page_description" v-model="page_description" :editor="new_page_editor" :config="editor_config" name="page[description]">
                  </ckeditor>
                </div>
              </div>
              <!-- END Page description -->

              <!-- Page visible homepage -->
              <div class="row form-group">
                <label class="col-sm-3 col-form-label input-label">Visible sur la page d'accueil ?</label>
                <div class="col-sm-9 my-auto">
                  <div class="form-check form-check-inline">
                    <input type="radio" name="page[visible_homepage]" id="new_page_accueil_yes"
                           class="form-check-input" value="1">
                    <label for="new_page_accueil_yes" class="form-check-label">Oui</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input type="radio" name="page[visible_homepage]" id="new_page_accueil_no" checked="checked"
                           class="form-check-input" value="0">
                    <label for="new_page_accueil_no" class="form-check-label">Non</label>
                  </div>
                </div>
              </div>
              <!-- END Page visible homepage -->


            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Annuler</button>
              <button type="submit" class="btn btn-primary">Enregistrer</button>
            </div>
          </form>
        </div>
      </div>
    </div>


    <div class="modal fade" id="partner_modal" tabindex="-1" role="dialog"
         aria-labelledby="Modal partenaire" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="payment_cash_modal_title">{{ modal_partner_title }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form id="partner_form"
                enctype="multipart/form-data"
                method="post"
                @submit.prevent="post_partner">

            <input type="hidden" :value="partner.id"
                   :name="'partner[id]'"
                   :id="'partner_id_' + partner.id">

            <input type="hidden" :value="page.id"
                   :name="'partner[page_id]'"
                   :id="'partner_page_id_' + page.id">


            <div class="modal-body">
              <div class="mt-2">

                <div class="row form-group">
                  <label for="partner_logo" class="col-sm-3 col-form-label input-label">Logo</label>

                  <div class="col-sm-9">

                    <figure class="col-md-6 align-content-stretch mb-5 mb-md-0"
                            data-toggle="tooltip" data-placement="top"
                            title="Logo de la structure">
                      <img class="img-fluid max-w-33rem w-md-100 h-auto d-block mx-auto border border-light border-3"
                           id="partner_logo"
                           :src="partner_logo"
                           alt="Logo du partenaire"/>
                      <figcaption class="small bg-light text-center max-w-33rem w-md-100 mx-auto p-1">
                        Ajouter / modifier la photo
                        <a href="javascript:;" id="changePictureBtn" class="stretched-link" data-toggle="modal"
                           data-target="#change_partner_logo">
                          <i class="fa fa-question-circle"></i>
                        </a>
                      </figcaption>
                    </figure>

                    <dlnk-clipper
                        modal_id="change_partner_logo"
                        @imgURL="set_partner_logo($event)"
                        :crop_ratio="1">
                    </dlnk-clipper>

                  </div>
                </div>

                <div class="row form-group">
                  <label for="partner_title" class="col-sm-3 col-form-label input-label">Partenaire</label>
                  <div class="col-sm-9">
                    <input type="text" name="partner[title]"
                           id="partner_title"
                           placeholder="Titre" aria-label="Titre" class="form-control" v-model="partner_title">
                  </div>
                </div>

                <div class="row form-group">
                  <label for="partner_url" class="col-sm-3 col-form-label input-label">Site Web</label>
                  <div class="col-sm-9">
                    <input type="url" name="partner[url]"
                           id="partner_url"
                           placeholder="Site web : https://www.dalink.fr" aria-label="Site Web" class="form-control"
                           v-model="partner_url">
                  </div>
                </div>

                <!-- Partner global -->
                <div class="row form-group">
                  <label class="col-sm-3 col-form-label input-label">Partenaire global ?</label>
                  <div class="col-sm-9 my-auto">
                    <div class="form-check form-check-inline">
                      <input type="radio" name="partner[global]" id="partner_global_oui"
                             class="form-check-input" value="1"
                             :checked="partner_global === true">
                      <label for="salaries_oui" class="form-check-label">Oui</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input type="radio" name="partner[global]" id="partner_global_non" checked="checked"
                             class="form-check-input" value="0"
                             :checked="partner_global === false">
                      <label for="salaries_non" class="form-check-label">Non</label>
                    </div>
                  </div>
                </div>
                <!-- END Page visible homepage -->

                <div class="row form-group">
                  <label for="partner_short_description" class="col-sm-3 col-form-label input-label">Résumé</label>
                  <div class="col-sm-9">
                    <input type="text" name="partner[short_description]"
                           id="partner_short_description"
                           placeholder="Résumé" aria-label="Titre" class="form-control"
                           v-model="partner_short_description">
                  </div>
                </div>

                <div class="row form-group mb-0">
                  <label for="partner_description"
                         class="col-sm-3 col-form-label input-label">Description</label>
                  <div class="col-sm-9">
                    <ckeditor :editor="editor" v-model="partner_description" :config="editor_config"
                              name="partner[description]">
                    </ckeditor>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Annuler">Annuler</button>
              <button type="submit" class="btn btn-primary">Enregistrer</button>
            </div>

          </form>

        </div>
      </div>
    </div>


    <div v-if="step==='pages'" id="pages">

      <div class="bg-blue" style="background-image: url('/themes/template/img/components/abstract-shapes-20.svg');">
        <div class="container space-1">
          <div class="row align-items-center">
            <div class="col">
              <div class="d-none d-md-block">
                <h1 class="h2 text-white">Gestion des pages</h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Pages-->
      <div class="tab-wrapper">

        <button data-toggle="modal" data-target="#new_page_modal" class="btn btn-primary my-2 float-right">
          <i class="fas fa-plus"></i>&nbsp;Ajouter une page
        </button>

        <table class="table">
          <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Titre</th>
            <th scope="col">Description</th>
            <th scope="col">Statut</th>
            <th scope="col">Homepage</th>
            <th scope="col">Action</th>
          </tr>
          </thead>
          <tbody>

          <tr v-for="page in pages" :key="page.id">
            <th scope="row">
              {{ page.id }}
            </th>
            <td>
              <a href="javascript:void(0);" @click="open_page(page.id)">
                {{ page.title }}
              </a>
            </td>
            <td>
              {{ page.description }}
            </td>
            <td>{{ page.status }}</td>
            <td>
              <i v-if="page.visible_homepage == '1'" class="fas fa-check text-success"></i>
              <i v-else class="fas fa-times-circle text-danger"></i>

            </td>
            <td>
              <a class="btn btn-xs btn-icon btn-outline-primary rounded-circle" @click="open_page(page.id)"
                 data-toggle="tooltip" data-placement="top" :title="'Modifier la page ' + page.title">
                <i class="fas fa-edit"></i>
              </a>
              <a href="javascript:void(0);" class="btn btn-xs btn-icon btn-outline-danger rounded-circle"
                 data-toggle="tooltip" data-placement="top" title="Supprimer la page"
                 @click="delete_page(page.id)">
                <i class="fas fa-trash"></i>
              </a>

            </td>
          </tr>

          </tbody>
        </table>

      </div>
      <!-- End Pages  -->
    </div>

    <div id="page" v-if="step==='page'">

      <div class="bg-blue" style="background-image: url('/themes/template/img/components/abstract-shapes-20.svg');">
        <div class="container space-1 space-top-lg-2 space-bottom-lg-3">
          <div class="row align-items-center">
            <div class="col">
              <div class="d-none d-md-block">
                <h1 class="h2 text-white">Gestion de la page &laquo; {{ page.title }} &raquo; </h1>
              </div>

              <div class="d-none d-md-block">
                <h3 class="text-white" v-html="page.title_2"></h3>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="container space-1 space-top-lg-0 space-bottom-lg-2 mt-lg-n10">

        <div class="row">
          <div class="col-lg-12">
            <div class="card mb-3 mb-lg-5">
              <div class="card-header">
                <div class="">
                  <h3 class="mb-0 float-left">Page</h3>
                  <span class="float-right">
                    <button type="button" class="btn btn-primary" @click="page_list()">
                      <i class="fas fa-chevron-left" aria-hidden="true"></i> &nbsp;
                      Retour
                    </button>
                  </span>
                </div>
              </div>
              <div>

                <form id="page_form"
                      method="patch"
                      @submit.prevent="post_page">

                  <input type="hidden" :value="page.id"
                         :name="'page[id]'"
                         :id="'page_id_' + page.id">


                  <div class="card-body">
                    <h4 class="mb-4">Détail de la page &laquo; {{ page.title }} &raquo;</h4>

                    <!-- Page title -->
                    <div class="row form-group">
                      <label for="title" class="col-sm-3 col-form-label input-label">Titre</label>
                      <div class="col-sm-9">
                        <input type="text" name="page[title]" id="title" placeholder="Titre de la page"
                               aria-label="Titre de la page"
                               class="form-control" v-model="page_title">
                        <div v-if="invalid_page_title" class="text-danger">
                          Le titre de la page doit contenir entre 3 et 255 caractères.
                        </div>
                      </div>
                    </div>
                    <!-- END Page title -->

                    <!-- Page title -->
                    <div class="row form-group">
                      <label for="title" class="col-sm-3 col-form-label input-label">Titre 2</label>
                      <div class="col-sm-9">
                        <input type="text" name="page[title_2]" id="title_2" placeholder="Titre 2 de la page"
                               aria-label="Titre 2 de la page"
                               class="form-control" v-model="page_title_2">
                        <div v-if="invalid_page_title_2" class="text-danger">
                          Le titre 2 de la page doit contenir entre 0 et 128 caractères.
                        </div>
                      </div>
                    </div>
                    <!-- END Page title -->

                    <!-- Page title -->
                    <div class="row form-group">
                      <label for="title" class="col-sm-3 col-form-label input-label">
                        Text bouton &laquo; Nous rejoindre &raquo;
                      </label>
                      <div class="col-sm-9">
                        <input type="text" name="page[join_us]" id="join_us" placeholder="Nous rejoindre"
                               aria-label="Titre 2 de la page"
                               class="form-control" v-model="page_join_us">
                        <div v-if="invalid_page_join_us" class="text-danger">
                          Le text du bouton &laquo; Nous rejoindre &raquo; doit contenir entre 0 et 128 caractères.
                        </div>
                      </div>
                    </div>
                    <!-- END Page title -->

                    <!-- Page description -->
                    <div class="row form-group">
                      <label for="page_description" class="col-sm-3 col-form-label input-label">
                        Description
                      </label>
                      <div class="col-sm-9">
                        <ckeditor id="page_description" :editor="editor" v-model="page_description"
                                  :config="editor_config" name="page[description]">
                        </ckeditor>
                      </div>
                    </div>
                    <!-- END Page description -->

                    <!-- Page visible homepage -->
                    <div class="row form-group">
                      <label class="col-sm-3 col-form-label input-label">Visible sur la page d'accueil ?</label>
                      <div class="col-sm-9 my-auto">
                        <div class="form-check form-check-inline">
                          <input type="radio" name="page[visible_homepage]" id="salaries_oui"
                                 class="form-check-input" value="1"
                                 :checked="page_visible_homepage === true">
                          <label for="salaries_oui" class="form-check-label">Oui</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input type="radio" name="page[visible_homepage]" id="salaries_non" checked="checked"
                                 class="form-check-input" value="0"
                                 :checked="page_visible_homepage === false">
                          <label for="salaries_non" class="form-check-label">Non</label>
                        </div>
                      </div>
                    </div>
                    <!-- END Page visible homepage -->

                    <div class="card-footer">
                      <button type="submit" class="btn btn-primary float-right">
                        <i class="fa fa-save" aria-hidden="true"></i>&nbsp;
                        Enregistrer
                      </button>
                    </div>

                  </div>
                </form>
              </div>
            </div>

            <div class="card mb-3 mb-lg-5">
              <div class="card-header">
                <div class="d-flex justify-content-between align-items-center">
                  <h3 class="mb-0">Listes des partenaires</h3>
                  <a href="javascript:" data-toggle="modal" data-target="#partner_modal"
                     class="btn btn-primary h-100" @click="new_partner()">
                    <i class="fa fa-plus" aria-hidden="true"></i>&nbsp;
                    Ajouter un partenaire
                  </a>
                </div>
              </div>
              <div>
                <div class="card-body">
                  <!-- Page title -->


                  <div id="partners_list" class="col-12">


                    <table class="table">
                      <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Logo</th>
                        <th scope="col">Titre</th>
                        <th scope="col">Status</th>
                        <th scope="col">Global ?</th>
                        <th scope="col">Action</th>
                      </tr>
                      </thead>
                      <tbody>

                      <tr v-for="partner in page.partners" :key="partner.id">
                        <th scope="row">
                          {{ partner.id }}
                        </th>
                        <td>
                          <img :src="partner.logo" alt=""
                               class="img-fluid max-w-33rem w-md-100 h-auto d-block mx-auto border border-light border-3">
                        </td>
                        <td>
                          {{ partner.title }}
                        </td>
                        <td>
                          {{ partner.status }}
                        </td>
                        <td>
                          <a href="javascript:" v-if="partner.global" class="text-success fa fa-thumbs-up"
                             @click="set_partner_global(partner.id, false)"></a>
                          <a href="javascript:" role='button' v-else class="text-danger fa fa-thumbs-down"
                             @click="set_partner_global(partner.id, true)"></a>
                        </td>
                        <td>
                          <a class="btn btn-xs btn-icon btn-outline-primary rounded-circle"
                             @click="edit_partner(partner)"
                             data-toggle="modal" data-target="#partner_modal"
                             data-tooltim="tooltip" data-placement="top"
                             :title="'Modifier le partenaire ' + partner.title">
                            <i class="fas fa-edit"></i>
                          </a>
                          <a href="javascript:void(0);" class="btn btn-xs btn-icon btn-outline-danger rounded-circle"
                             data-toggle="tooltip" data-placement="top" title="Supprimer le partenaire"
                             @click="delete_partner(partner.id)">
                            <i class="fas fa-trash"></i>
                          </a>

                        </td>
                      </tr>

                      </tbody>
                    </table>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>

import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
  props: {
    'group_id': Number,
  },
  data: function () {
    return {
      message: '',
      message_type: '',

      pages: Array,
      step: String,
      page: Object,
      partner: Object,

      open_partner_modal: Boolean,
      modal_partner_title: String,

      page_title: String,
      page_title_2: String,
      page_join_us: String,
      page_description: "",
      page_visible_homepage: Boolean,

      partner_description: "",
      partner_short_description: "",
      partner_title: "",
      partner_url: "",
      partner_id: 0,
      partner_global: false,
      partner_logo: "",

      invalid_page_title: Boolean,
      invalid_page_title_2: Boolean,
      invalid_page_jpon_us: Boolean,
      invalid_page_description: Boolean,
      invalid_page_join_us: Boolean,


      invalid_new_page_title: Boolean,
      invalid_new_page_title_2: Boolean,
      invalid_new_page_jpon_us: Boolean,
      invalid_new_page_description: Boolean,
      invalid_new_page_join_us: Boolean,

      new_page_editor: ClassicEditor,
      editor: ClassicEditor,
      editor_config: {
        toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote', 'undo', 'redo'],
        heading: {
          options: [
            {model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph'},
            {model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1'},
            {model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2'},
            {model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3'}
          ]
        }
      }
    }
  },
  mounted() {
    this.step = 'pages'
    this.page_title = ''
    this.page_visible_homepage = false

    this.open_partner_modal = false

    this.invalid_page_title = false
    this.invalid_page_description = false
    this.invalid_page_title_2 = false
    this.invalid_page_join_us = false

    this.invalid_new_page_title = false
    this.invalid_new_page_description = false
    this.invalid_new_page_title_2 = false
    this.invalid_new_page_join_us = false


    this.partner_logo = "/modules/dlnkaap/img/socialmedia.jpg"

    this.get_pages()
  },

  computed: {},

  methods: {
    close_message: function () {
      this.message = null;
    },

    edit_partner: function (partner) {
      this.partner = partner
      this.modal_partner_title = "Modification d'un partenaire"
      this.partner_description = this.partner.description
      this.partner_id = this.partner.id
      this.partner_title = this.partner.title
      this.partner_url = this.partner.url
      this.partner_global = this.partner.global
      this.partner_short_description = this.partner.short_description
      this.partner_logo = this.partner.logo
      this.open_partner_modal = true
    },

    new_partner: function () {

      this.partner.id = 0
      this.partner.title = ""
      this.partner.description = ""

      this.partner_id = 0
      this.partner_title = ""
      this.partner_url = ""
      this.partner_description = ""
      this.partner_short_description = ""


      this.modal_partner_title = "Ajout d'un partenaire"
      this.open_partner_modal = true
    },

    delete_partner: async function (id) {
      const _this = this;

      if (confirm('Attention, êtes-vous certain de vouloir supprimer ce partenaire.')) {

        let [secure_key, customer_id, api_url] = await get_token_2()
        api_url += "/partner_partners/" + id + ".json"
        api_url += '?secure_key=' + secure_key
        api_url += '&customer_id=' + customer_id


        axios.delete(api_url)
            .then(function (response) {
              _this.message = "Partenaire supprimé";
              _this.message_type = "alert-success";
              _this.open_page(_this.page.id)
            })
            .catch(function (error) {
              _this.errors = error;
              _this.message = "Une erreur est survenue. Contactez votre support";
              _this.message_type = "alert-danger";
            });
      }
    },

    set_partner_global: async function (id, value) {
      const _this = this;

      let [secure_key, customer_id, api_url] = await get_token_2()
      api_url += `/partner_partners/${id}.json`
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      const form_data = new FormData();

      form_data.append('partner[global]', value)

      axios({
        method: 'patch',
        url: api_url,
        data: form_data
      })
          .then(function (response) {
            _this.message = "Partenaire modifié";
            _this.message_type = "alert-success";
            _this.open_page(_this.page.id)
          })
          .catch(function (error) {
            _this.errors = error
            _this.message = "Une erreur est survenue. Contactez votre support";
            _this.message_type = "alert-danger";
          });

    },

    post_partner: async function () {

      const _this = this;
      let method = ""

      let [secure_key, customer_id, api_url] = await get_token_2()

      if (_this.partner_id === 0) {
        method = 'post'
        api_url += "/partner_partners.json"
      } else {
        method = 'patch'
        api_url += `/partner_partners/${_this.partner_id}.json`
      }

      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      const form_element = document.getElementById("partner_form");
      const form_data = new FormData(form_element);

      form_data.append('partner[description]', _this.partner_description)
      form_data.append('logo_base64', _this.partner_logo)

      axios({
        method: method,
        url: api_url,
        data: form_data
      })
          .then(function (response) {
            _this.message = "Partenaire enregistré";
            _this.message_type = "alert-success";
            _this.open_page(_this.page.id)
            $('#partner_modal').modal('toggle')
          })
          .catch(function (error) {
            _this.errors = error
            _this.message = "Une erreur est survenue. Contactez votre support";
            _this.message_type = "alert-danger";
          });
    },

    post_page:function (event) {
      const _this = this;

      get_token_2().then(function (response) {

        const form_id = event.target.id

        let [secure_key, customer_id, api_url] = response

        let method = ""
        if(event.target.method === 'post') {
          method = 'post'
          api_url += `/partner_pages.json`
        } else {
          method = 'patch'
          api_url += `/partner_pages/${_this.page.id}.json`
        }

        api_url += '?secure_key=' + secure_key
        api_url += '&customer_id=' + customer_id

        const form_element = document.getElementById(form_id)
        const form_data = new FormData(form_element);

        form_data.append('page[description]', _this.page_description)

        axios({
          method: method,
          url: api_url,
          data: form_data
        })
            .then(function (response) {
              _this.message = "Page enregistrée";
              _this.message_type = "alert-success";

              if (method === 'patch') {
                _this.open_page(_this.page.id)
              } else {
                document.getElementById('new_page_modal').click()
              }

            })
            .catch(function (error) {
              console.log(error)
              _this.message = "Une erreur est survenue (PA-001). Contactez votre support";
              _this.message_type = "alert-danger";
            });
      })
    },

    page_list: function () {
      this.step = 'pages'
      this.get_pages()
    },

    open_page: function (id) {
      const _this = this
      _this.step = 'page'

      get_token_2().then(function (response){

        let [secure_key, customer_id, api_url] = response
        api_url += "/partner_pages/" + id + ".json"
        api_url += '?secure_key=' + secure_key
        api_url += '&customer_id=' + customer_id

        axios.get(api_url)
            .then(function (response) {
              _this.page = response.data
              _this.page_title = _this.page.title
              _this.page_title_2 = _this.page.title_2
              _this.page_join_us = _this.page.join_us
              _this.page_description = _this.page.description
              _this.page_visible_homepage = _this.page.visible_homepage
            })
            .catch(function (error) {
              _this.message = "Erreur";
              _this.message_type = "alert-danger"
            })
            .then(function () {
                  // always executed
                }
            );
      })

    },

    delete_page: function (id) {
      const _this = this;

      if (confirm('Attention, êtes-vous certain de vouloir supprimer cette page.')) {

        get_token_2().then(function (response) {
          let [secure_key, customer_id, api_url] = response
          api_url += `/partner_pages/${id}.json`
          api_url += '?secure_key=' + secure_key
          api_url += '&customer_id=' + customer_id

          axios({
            method: 'delete',
            url: api_url,
            headers: {"cache-control": "no-cache"},
          })
              .then(function (response) {
                _this.message = "Page supprimée";
                _this.message_type = "alert-success";
                _this.get_pages()
              })
              .catch(function (error) {
                _this.message = "Une erreur est survenue (PA-002). Contactez votre support";
                _this.message_type = "alert-danger";
              });
        })
      }
    },

    get_pages: async function () {
      const _this = this;

      let [secure_key, customer_id, api_url] = await get_token_2()
      api_url += "/partner_pages.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios.get(api_url)
          .then(function (response) {
            _this.pages = response.data
          })
          .catch(function (error) {
            _this.message = "Erreur";
            _this.message_type = "alert-danger"
          })
          .then(function () {
                // always executed
              }
          );
    },

    set_partner_logo: function (img_url) {
      this.partner_logo = img_url
    },


  }
}
</script>

<style scoped>

.bg-blue {
  background-color: #0049a4;
}

</style>